import { render } from "./CourseEthics.vue?vue&type=template&id=1ce8f952&scoped=true"
import script from "./CourseEthics.vue?vue&type=script&lang=js"
export * from "./CourseEthics.vue?vue&type=script&lang=js"

import "./CourseEthics.vue?vue&type=style&index=0&id=1ce8f952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce8f952"]])

export default __exports__